import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { GSAP_SCROLLTRIGGER_OPTIONS } from './gsap.types';

export const providers = (options?: Partial<gsap.plugins.ScrollTriggerInstanceVars>) => [
    {
        provide: GSAP_SCROLLTRIGGER_OPTIONS,
        useValue: options
    }
];

export function provideDfUiGsap(options?: Partial<gsap.plugins.ScrollTriggerInstanceVars>): EnvironmentProviders {
    return makeEnvironmentProviders(providers(options));
}
